import { render, staticRenderFns } from "./SettlementSubTab.vue?vue&type=template&id=7531fc4d&"
import script from "./SettlementSubTab.vue?vue&type=script&lang=js&"
export * from "./SettlementSubTab.vue?vue&type=script&lang=js&"
import style0 from "./SettlementSubTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Documents: require('/codebuild/output/src195787613/src/cc-portal/components/Documents.vue').default,SellerDetails: require('/codebuild/output/src195787613/src/cc-portal/components/SellerDetails.vue').default})
